import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { ToastContainer, toast } from "react-toastify"

import { useAuth } from "../context/userContext"

const Login = () => {
  const { refreshUser } = useAuth()
  const navigate = useNavigate()

  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false)

  const [inputValue, setInputValue] = useState({
    email: "",
    password: "",
  })

  const { email, password } = inputValue

  const handleOnChange = (e) => {
    const { name, value } = e.target
    setInputValue((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleError = (err) => toast.error(err, { position: "bottom-left" })

  const handleSuccess = (msg) => toast.success(msg, { position: "bottom-left" })

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(inputValue),
      })

      if (!res.ok) throw new Error("Login failed")

      const data = await res.json()

      if (data.success) {
        handleSuccess(data.message)

        // ✅ single source of truth
        await refreshUser()

        navigate("/account")
      } else {
        handleError(data.message)
      }
    } catch (err) {
      handleError("Unable to login")
    }

    setLoading(false)

    setInputValue({
      email: "",
      password: "",
    })
  }

  return (
    <div className="Login justify-content-center d-flex h-100 align-items-center">
      <div
        className="row col-xl-6 col-md-8 col-11 py-5 mx-2"
        style={{ maxWidth: "800px" }}
      >
        <form
          onSubmit={handleSubmit}
          className="p-4 p-md-5 border rounded-3 bg-light"
        >
          <h1 className="display-2 mb-4">Log In</h1>

          <div className="form-floating mb-3">
            <input
              type="email"
              name="email"
              className="form-control"
              value={email}
              onChange={handleOnChange}
              required
            />
            <label>Email address</label>
          </div>

          <div className="form-floating input-group mb-3">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              className="form-control"
              value={password}
              onChange={handleOnChange}
              required
            />

            <span
              className="input-group-text rounded-end show-pass-container"
              onClick={() => setShowPassword((s) => !s)}
            >
              <img
                src={
                  showPassword
                    ? "assets/eye-icon-disabled.svg"
                    : "assets/eye-icon.svg"
                }
                alt=""
              />
            </span>

            <label>Password</label>
          </div>

          <button
            className="w-100 btn btn-lg btn-primary"
            type="submit"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Log In"}
          </button>

          <hr className="mt-4 mb-3" />

          <small>
            <Link to="/forgot-password">Forgot password?</Link>
          </small>

          <br />

          <small>
            Don’t have an account? <Link to="/signup">Sign up</Link>
          </small>
        </form>

        <ToastContainer />
      </div>
    </div>
  )
}

export default Login
